export default "__VITE_ASSET__Bgm1EaCm__"